import React from "react";
import Header from "./Header";

interface Props extends React.HTMLAttributes<HTMLElement> {
  children: React.ReactNode;
}

function BigHeader(props: Props) {
  return (
    <Header level={1} {...props}>
      {props.children}
    </Header>
  );
}

export default BigHeader;
